import * as React from 'react';

// Keep the list and its badges on the same local date window, including after app resume.
export const useCalendarTodoDate = (active?: boolean): number => {
  const [now, setNow] = React.useState(Date.now);

  React.useEffect(() => {
    let timer: number;
    const refreshDate = () => {
      window.clearTimeout(timer);
      const currentTime = Date.now();
      setNow(currentTime);
      const midnight = new Date(currentTime);
      midnight.setHours(24, 0, 0, 0);
      timer = window.setTimeout(refreshDate, midnight.getTime() - currentTime + 10);
    };
    refreshDate();
    window.addEventListener('focus', refreshDate);
    document.addEventListener('visibilitychange', refreshDate);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('focus', refreshDate);
      document.removeEventListener('visibilitychange', refreshDate);
    };
  }, [active]);

  return now;
};



// WEBPACK FOOTER //
// ./src/components/todo/useCalendarTodoDate.ts